/* Camping Store Deals — interactions. Vanilla, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- word split for headline reveals ---------- */
  function split(el) {
    if (el.dataset.splitDone) return;
    el.dataset.splitDone = '1';
    let i = 0;
    const walk = (node) => {
      Array.from(node.childNodes).forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            const w = document.createElement('span'); w.className = 'w';
            const s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(root = document) {
    $$('.csd-split', root).forEach(split);
    const els = $$('[data-reveal], .csd-split', root).filter((e) => !e.classList.contains('is-in'));
    if (!('IntersectionObserver' in window) || reduce) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- header ---------- */
  function initHeader() {
    const wrap = $('.csd-header-wrap');
    if (!wrap) return;
    const header = $('.csd-header', wrap);
    const setH = () => document.documentElement.style.setProperty('--csd-header-h', wrap.offsetHeight + 'px');
    setH(); window.addEventListener('resize', setH);
    let last = 0, ticking = false;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      const searchFocused = wrap.contains(document.activeElement) && document.activeElement.matches('input');
      if (y > 320 && y > last + 4 && !searchFocused) wrap.classList.add('is-hidden');
      else if (y < last - 4 || y < 320) wrap.classList.remove('is-hidden');
      last = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });

    const drawer = $('.csd-drawer');
    if (drawer) {
      const open = () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; $('.csd-drawer__close', drawer)?.focus(); };
      const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
      $$('[data-drawer-open]').forEach((b) => b.addEventListener('click', open));
      $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
    // keyboard: close mega on escape
    $$('.csd-nav__item').forEach((item) => item.addEventListener('keydown', (e) => { if (e.key === 'Escape') document.activeElement.blur(); }));
  }

  /* ---------- hero parallax + fireflies ---------- */
  function initHero() {
    $$('.csd-hero').forEach((hero) => {
      const flies = $('.csd-hero__flies', hero);
      if (flies && !reduce && !flies.childElementCount) {
        for (let i = 0; i < 18; i++) {
          const f = document.createElement('i'); f.className = 'csd-fly';
          f.style.left = (Math.random() * 100) + '%';
          f.style.top = (45 + Math.random() * 45) + '%';
          f.style.setProperty('--t', (7 + Math.random() * 8).toFixed(1) + 's');
          f.style.setProperty('--dl', (-Math.random() * 10).toFixed(1) + 's');
          f.style.setProperty('--x', (Math.random() * 120 - 60).toFixed(0) + 'px');
          f.style.setProperty('--y', (-40 - Math.random() * 90).toFixed(0) + 'px');
          flies.appendChild(f);
        }
      }
      if (reduce) return;
      const layers = $$('[data-speed]', hero);
      let raf = null;
      const update = () => {
        const r = hero.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) { raf = null; return; }
        const p = Math.min(Math.max(-r.top / r.height, 0), 1);
        layers.forEach((l) => { l.style.transform = `translate3d(0, ${(p * 100 * parseFloat(l.dataset.speed)).toFixed(2)}px, 0)`; });
        const c = $('.csd-hero__content', hero);
        if (c) { c.style.opacity = String(1 - p * 1.3); c.style.transform = `translate3d(0, ${p * 60}px, 0)`; }
        raf = null;
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- rails + tabs ---------- */
  function initRails(root = document) {
    $$('.csd-rail', root).forEach((rail) => {
      const tracks = () => $$('.csd-rail__track', rail).filter((t) => !t.closest('[hidden]'));
      const bar = $('.csd-rail__bar i', rail);
      const upd = () => {
        const t = tracks()[0]; if (!t || !bar) return;
        const max = t.scrollWidth - t.clientWidth;
        const vis = t.clientWidth / t.scrollWidth;
        bar.style.width = Math.max(vis * 100, 12) + '%';
        bar.style.transform = `translateX(${max > 0 ? (t.scrollLeft / max) * ((1 / Math.max(vis, .12)) - 1) * 100 : 0}%)`;
      };
      $$('.csd-rail__track', rail).forEach((t) => {
        t.addEventListener('scroll', upd, { passive: true });
        // drag to scroll (mouse only)
        let down = false, sx = 0, sl = 0, moved = false;
        t.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = t.scrollLeft; });
        window.addEventListener('pointerup', () => { if (down) { down = false; t.classList.remove('is-drag'); } });
        t.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; t.classList.add('is-drag'); } t.scrollLeft = sl - dx; });
        t.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      });
      $$('[data-rail-prev],[data-rail-next]', rail).forEach((b) => b.addEventListener('click', () => {
        const t = tracks()[0]; if (!t) return;
        const dir = b.hasAttribute('data-rail-next') ? 1 : -1;
        t.scrollBy({ left: dir * t.clientWidth * 0.8, behavior: 'smooth' });
      }));
      const tabs = $$('.csd-tab', rail.closest('section') || rail);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((x) => x.setAttribute('aria-selected', String(x === tab)));
        $$('.csd-rail__panel', rail).forEach((p) => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        const panel = $('#' + tab.getAttribute('aria-controls'));
        if (panel) initReveal(panel);
        upd();
      }));
      upd(); window.addEventListener('resize', upd);
    });
  }

  /* ---------- quick add ---------- */
  function initQuickAdd() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const drawer = document.querySelector('cart-drawer');
      const fd = new FormData();
      fd.append('id', btn.dataset.quickAdd); fd.append('quantity', '1');
      if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
      try {
        const res = await fetch((window.routes && routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } });
        const data = await res.json();
        if (data.status) throw new Error(data.description || 'Could not add');
        btn.classList.add('is-done');
        if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(data); }
        else window.location.href = '/cart';
      } catch (err) {
        window.location.href = btn.closest('a')?.href || '/cart';
      } finally { btn.classList.remove('is-loading'); setTimeout(() => btn.classList.remove('is-done'), 1600); }
    });
  }

  /* ---------- sticky story ---------- */
  function initStory() {
    $$('.csd-story').forEach((story) => {
      const steps = $$('.csd-step', story);
      const imgs = $$('.csd-story__img', story);
      const bars = $$('.csd-story__hud i', story);
      const num = $('.csd-story__num', story);
      const setActive = (i) => {
        steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
        imgs.forEach((m, k) => m.classList.toggle('is-active', k === i));
        if (num) num.textContent = String(i + 1).padStart(2, '0');
      };
      if (!('IntersectionObserver' in window)) { setActive(0); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) setActive(steps.indexOf(en.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach((s) => io.observe(s));
      setActive(0);
      let raf = null;
      const prog = () => {
        steps.forEach((s, k) => {
          const r = s.getBoundingClientRect();
          const p = Math.min(Math.max((innerHeight * .5 - r.top) / r.height, 0), 1);
          if (bars[k]) bars[k].style.setProperty('--p', p.toFixed(3));
        });
        raf = null;
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(prog); }, { passive: true });
    });
  }

  /* ---------- counters ---------- */
  function initCounters() {
    const els = $$('[data-count]');
    if (!els.length) return;
    const fmt = (n) => n.toLocaleString('en-US');
    const run = (el) => {
      const target = parseFloat(el.dataset.count) || 0;
      const suffix = el.dataset.suffix || '';
      if (reduce) { el.textContent = fmt(target) + suffix; return; }
      const t0 = performance.now(), dur = 1800;
      const tick = (t) => {
        const p = Math.min((t - t0) / dur, 1);
        const e = 1 - Math.pow(1 - p, 4);
        el.textContent = fmt(Math.round(target * e)) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } }), { threshold: .4 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- gear finder ---------- */
  function initFinder() {
    $$('[data-finder]').forEach((f) => {
      const qs = $$('.csd-q', f);
      const bar = $('.csd-finder__progress i', f);
      const back = $('[data-finder-back]', f);
      const restart = $$('[data-finder-restart]', f);
      const answers = {};
      let cur = 0;
      const show = (i) => {
        cur = i;
        qs.forEach((q, k) => q.classList.toggle('is-active', k === i));
        if (bar) bar.style.width = ((i) / (qs.length - 1)) * 100 + '%';
        if (back) back.style.visibility = i > 0 && i < qs.length - 1 ? 'visible' : 'hidden';
      };
      $$('.csd-opt', f).forEach((o) => o.addEventListener('click', () => {
        const q = o.closest('.csd-q');
        $$('.csd-opt', q).forEach((x) => x.classList.remove('is-picked'));
        o.classList.add('is-picked');
        answers[q.dataset.key] = o.dataset.value;
        setTimeout(() => {
          const next = qs.indexOf(q) + 1;
          if (next === qs.length - 1) buildResult();
          show(next);
        }, 260);
      }));
      back?.addEventListener('click', () => show(Math.max(0, cur - 1)));
      restart.forEach((b) => b.addEventListener('click', () => { $$('.csd-opt', f).forEach((x) => x.classList.remove('is-picked')); show(0); }));
      const map = JSON.parse($('[data-finder-map]', f)?.textContent || '{}');
      function buildResult() {
        const list = $('.csd-result__list', f); if (!list) return;
        const picks = [];
        const add = (arr) => (arr || []).forEach((x) => { if (!picks.find((p) => p.url === x.url)) picks.push(x); });
        add(map[answers.trip]); add(map[answers.season]); add(map[answers.need]);
        list.innerHTML = picks.slice(0, 5).map((p) => `<li><a href="${p.url}">${p.title}<span>Shop now →</span></a></li>`).join('');
        const tag = $('[name="contact[tags]"]', f);
        if (tag) tag.value = ['newsletter', 'gear-finder', answers.trip, answers.season].filter(Boolean).join(',');
      }
      show(0);
    });
  }

  /* ---------- checklist ---------- */
  function initChecklist() {
    $$('[data-checklist]').forEach((c) => {
      const key = 'csd-check-' + (c.dataset.checklist || 'default');
      const boxes = $$('input[type="checkbox"]', c);
      let saved = {};
      try { saved = JSON.parse(store.get(key) || '{}'); } catch (e) {}
      boxes.forEach((b) => { if (saved[b.id]) b.checked = true; });
      const ring = $('.csd-check__ring .fg', c);
      const out = $('[data-check-count]', c);
      const len = ring ? 2 * Math.PI * parseFloat(ring.getAttribute('r')) : 0;
      if (ring) { ring.style.strokeDasharray = len; }
      const upd = () => {
        const done = boxes.filter((b) => b.checked).length;
        const p = boxes.length ? done / boxes.length : 0;
        if (ring) ring.style.strokeDashoffset = String(len * (1 - p));
        if (out) out.textContent = Math.round(p * 100) + '%';
        const s = {}; boxes.forEach((b) => { if (b.checked) s[b.id] = 1; }); store.set(key, JSON.stringify(s));
      };
      boxes.forEach((b) => b.addEventListener('change', upd));
      upd();
    });
  }

  /* ---------- popup ---------- */
  function initPopup() {
    const pop = $('.csd-pop');
    if (!pop) return;
    const teaser = $('.csd-tab-teaser');
    const KEY = 'csd-pop-state';
    const params = new URLSearchParams(location.search);
    const posted = params.get('customer_posted') === 'true' || pop.dataset.posted === 'true';
    const open = () => { pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); teaser?.classList.remove('is-shown'); setTimeout(() => $('input[type="email"]', pop)?.focus({ preventScroll: true }), 400); };
    const close = (remember = true) => {
      pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true');
      if (remember) store.set(KEY, 'closed:' + Date.now());
      if (teaser && store.get(KEY) !== 'joined') teaser.classList.add('is-shown');
    };
    $$('[data-pop-close]', pop).forEach((b) => b.addEventListener('click', () => close()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    teaser?.addEventListener('click', open);
    $$('[data-pop-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('.csd-code').forEach((c) => c.addEventListener('click', () => { navigator.clipboard?.writeText(c.dataset.code || c.textContent.trim()); c.querySelector('small') && (c.querySelector('small').textContent = 'Copied!'); }));
    if (posted && pop.dataset.formSuccess === 'true') { store.set(KEY, 'joined'); if (!$('.csd-club')) open(); return; }
    const state = store.get(KEY) || '';
    if (state === 'joined') return;
    if ($('.csd-club')) return; // the Club page has its own signup
    if (state.startsWith('closed:')) {
      const days = (Date.now() - parseInt(state.split(':')[1], 10)) / 864e5;
      if (days < (parseFloat(pop.dataset.snooze) || 5)) { teaser?.classList.add('is-shown'); return; }
    }
    if (window.Shopify && Shopify.designMode) return;
    const delay = (parseFloat(pop.dataset.delay) || 12) * 1000;
    let fired = false;
    const fire = () => { if (fired) return; fired = true; open(); };
    setTimeout(fire, delay);
    const onScroll = () => { if (window.scrollY / (document.body.scrollHeight - innerHeight) > .55) { fire(); window.removeEventListener('scroll', onScroll); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY < 8) fire(); });
  }

  /* ---------- sticky add to cart (product) ---------- */
  function initStickyAtc() {
    const bar = $('.csd-sticky-atc');
    const btn = $('.product-form__submit');
    if (!bar || !btn) return;
    const io = new IntersectionObserver(([en]) => bar.classList.toggle('is-shown', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
    io.observe(btn);
    $('[data-sticky-buy]', bar)?.addEventListener('click', () => { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => btn.click(), 450); });
  }

  /* ---------- misc ---------- */
  function initMisc() {
    $$('.csd-seo__toggle').forEach((b) => b.addEventListener('click', () => {
      const s = b.closest('.csd-seo'); const o = s.classList.toggle('is-open');
      b.textContent = o ? (b.dataset.less || 'Show less') : (b.dataset.more || 'Read more');
    }));
    // tilt on bento tiles
    if (!reduce && window.matchMedia('(hover: hover)').matches) {
      $$('.csd-tile').forEach((t) => {
        t.addEventListener('pointermove', (e) => {
          const r = t.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          t.style.transform = `perspective(900px) rotateX(${(-y * 4).toFixed(2)}deg) rotateY(${(x * 5).toFixed(2)}deg) translateY(-4px)`;
        });
        t.addEventListener('pointerleave', () => { t.style.transform = ''; });
      });
    }
    // club card tilt
    if (!reduce && window.matchMedia('(hover: hover)').matches) {
      $$('[data-tilt]').forEach((c) => {
        const host = c.parentElement || c;
        host.addEventListener('pointermove', (e) => {
          const r = c.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
          c.style.transform = `rotateX(${(-y * 16).toFixed(2)}deg) rotateY(${(x * 22).toFixed(2)}deg)`;
        });
        host.addEventListener('pointerleave', () => { c.style.transform = ''; });
      });
    }
    // magnetic buttons
    if (!reduce && window.matchMedia('(hover: hover)').matches) {
      $$('[data-magnetic]').forEach((b) => {
        b.addEventListener('pointermove', (e) => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px, ${(e.clientY - r.top - r.height / 2) * .25}px)`; });
        b.addEventListener('pointerleave', () => { b.style.transform = ''; });
      });
    }
  }

  function boot() {
    initReveal(); initHeader(); initHero(); initRails(); initQuickAdd(); initStory();
    initCounters(); initFinder(); initChecklist(); initPopup(); initStickyAtc(); initMisc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initRails(e.target); initHero(); initStory(); initCounters(); initFinder(); initChecklist(); initMisc(); });
})();
